"use client";
import {JSX} from "react";

import {Spinner} from "../spinner/spinner";

import "./styles/spinner-overlay.scss";

export interface SpinnerOverlayProps {
    loading: boolean;
    size?: "small" | "medium" | "large";
    variant?: "overlay" | "container";
    className?: string;
    zIndex?: number;
}

/**
 * SpinnerOverlay Component
 * Displays a spinner with optional overlay or container background
 *
 * @param loading - Whether to show the spinner
 * @param size - Size of the spinner (small, medium, large)
 * @param variant - "overlay" for blocking overlay with backdrop, "container" for simple container
 * @param className - Additional CSS class name
 * @param zIndex - Override z-index for the overlay
 */
export function SpinnerOverlay({loading, size = "medium", variant = "overlay", className = "", zIndex}: SpinnerOverlayProps): JSX.Element | null {
    if (!loading) {
        return null;
    }

    const baseClassName = `spinner-overlay spinner-overlay--${variant}`;
    const fullClassName = className ? `${baseClassName} ${className}` : baseClassName;
    const style = zIndex !== undefined ? {zIndex} : undefined;

    if (variant === "overlay") {
        return (
            <>
                <div className="spinner-overlay__backdrop" />
                <div className={fullClassName} style={style}>
                    <Spinner size={size} />
                </div>
            </>
        );
    }

    return (
        <div className={fullClassName} style={style}>
            <Spinner size={size} />
        </div>
    );
}
